module.exports = __webpack_public_path__ + "img/ex11.7c4c42cd.png";